import { Box, Button, Card, Text, useDisclosure, useToast, VStack } from "@chakra-ui/react";
import { Page } from "../../components/Page";
import PageHeader from "../../components/text/PageHeader";
import { useGetAllOrganizations } from "../../hooks/query/esg-admin/esg-admin";
import DataTableV2 from "../../components/DataTable/DateTableV2";
import React, { useMemo } from "react";
import LocalSpinner from "../../components/LocalSpinner";
import ModuleListPopup from "./ModuleListPopup";
import { showSuccessToast } from "../../utils";
import CreateOrgPopup from "./CreateOrgPopup";
import A, {AButton} from "components/A";

const OrganizationList = () => {
  const { isOpen: isModuleListOpen, onOpen: onModuleListOpen, onClose: onModuleListClose } = useDisclosure();
  const { isOpen: isCreateOrgOpen, onOpen: onCreateOrgOpen, onClose: onCreateOrgClose } = useDisclosure();
  const [selectedOrg, setSelectedOrg] = React.useState(null);

  const { data: orgList, isLoading } = useGetAllOrganizations();

  const columns = useMemo(() => {
    const handleClickConfigure = (org) => {
      setSelectedOrg(org);
      onModuleListOpen();
    };

    return [
      {
        header: "Name",
        accessorKey: "name",
		cell: ({ row }) => {
			const { original } = row;
			return <A href={'/app/organization/'+original.tenantId}>{original.name}</A>;
		},
      },
      {
        header: "Tenant id",
        accessorKey: "tenantId",
      },
      {
        header: "Modules",
        accessorKey: "modules",
        cell: ({ row }) => {
          const { original } = row;
          return <Text>{original?.modules?.map((module) => module).join(", ")}</Text>;
        },
      },
	  {
        header: "Framework Tags",
        accessorKey: "accessTags",
        cell: ({ row }) => {
          const { original } = row;
          return <Text>{original?.accessTags?.map(tag => tag).join(", ")}</Text>;
        },
      },
      {
        header: "Action",
        accessorKey: "actions",
        cell: ({ row }) => {
          const { original } = row;

          return (
			<VStack>
            <Button onClick={() => handleClickConfigure(original)} variant="secondary" size="sm">
              Configure Modules
            </Button>
			<AButton variant="secondary" size="sm" href={'/app/organization/'+original.tenantId}>
				Edit Framework Tags
			</AButton>
			</VStack>
          );
		  // TODO add a button to edit the framework tags
        },
      },
    ];
  }, [onModuleListOpen]);

  if (isLoading) {
    return <LocalSpinner />;
  }

  return (
    <Page>
      <Box marginBlockStart="5">
        <PageHeader title="Organizations" subTitle="ESG Admin panel to manage organizations in the platform" />
        <ModuleListPopup organization={selectedOrg} isOpen={isModuleListOpen} onClose={onModuleListClose} />
        <CreateOrgPopup isOpen={isCreateOrgOpen} onClose={onCreateOrgClose} />

        <Box display="flex" justifyContent="flex-end" marginBlockEnd="4">
          <Button variant="primary" onClick={() => onCreateOrgOpen()}>
            Create Organization
          </Button>
        </Box>

        <DataTableV2
          columns={columns}
          data={orgList}
          isLoading={isLoading}
          serverSidePagination={false}
          showPaginator={false}
        />
      </Box>
    </Page>
  );
};

export default OrganizationList;
